export default __webpack_public_path__ + "static/media/scheme_old.dcf24a79.png";